import {storeInstance} from '@aofl/store/dist/legacy';
import {html, render} from 'lit-html';
import {sdoNs} from '../constants-enumerate';
import './sdo';

let last_target;
/**
 * @summary SimpleModal
 */
class SimpleModal {
  /**
   *
   * @param {Object} modals
   */
  static addModals(modals) {
    const modalsPayload = [];

    for (const key in modals) {
      if (!modals.hasOwnProperty(key)) continue;

      SimpleModal[key] = modals[key];
      modalsPayload.push({
        namespace: sdoNs.SIMPLE_MODAL,
        mutationId: 'addModal',
        payload: key
      });
    }

    if (modalsPayload.length) {
      storeInstance.commit(...modalsPayload);
    }
  }

  /**
   *
   *
   */
  static hide() {
    storeInstance.commit({
      namespace: sdoNs.SIMPLE_MODAL,
      mutationId: 'hideModals'
    });
    this.last_target?.focus();
  }

  /**
   *
   * @param {String} id
   */
  static show(id, data, event) {
    this.last_target = (event) ? event?.target : this.last_target;
    storeInstance.commit({
      namespace: sdoNs.SIMPLE_MODAL,
      mutationId: 'showModal',
      payload: {id, data}
    });
  }
}

const focustrap = (event) => {
  const dialog = modalContainer.querySelector('[role="dialog"]');
  if (!dialog) {
    return;
  }

  if (event.target.id === 'focus-pre') {
    dialog.shadowRoot.querySelector('[focuslast]')?.focus();
  } else if (event.target.id === 'focus-post') {
    dialog.shadowRoot.querySelector('[focusfirst]')?.focus();
  }
};

const escapeClose = (event) => {
  if (event.key === 'Escape') {
    SimpleModal.hide();
  }
};

const modalContainer = document.createElement('div');
modalContainer.setAttribute('id', 'simple-modal-container');
modalContainer.setAttribute('tabindex', '-1');
modalContainer.classList.add('modal-container');
storeInstance.subscribe(async () => {
  const state = storeInstance.getState();

  if (state[sdoNs.SIMPLE_MODAL].$activeModalId !== '' && typeof SimpleModal[state[sdoNs.SIMPLE_MODAL].$activeModalId] !== 'undefined') {
    const component = await SimpleModal[state[sdoNs.SIMPLE_MODAL].$activeModalId].resolve();
    const templateStr = `
      <div>
        <div tabindex=0 id="focus-pre"></div>
        <${component.default.is} role=dialog id="${state[sdoNs.SIMPLE_MODAL].$activeModalId}"></${component.default.is}>
        <div tabindex=0 id="focus-post"></div>
      <div>
    `;
    render(html([templateStr.trim()]), modalContainer);

    if (modalContainer.parentNode === null) {
      document.body.appendChild(modalContainer);
      modalContainer.addEventListener('focus', focustrap, true);
      document.addEventListener('keydown', escapeClose, true);
    }
  } else {
    render(html``, modalContainer);
    if (modalContainer.parentNode !== null) {
      modalContainer.parentNode.removeChild(modalContainer);
      modalContainer.removeEventListener('focus', focustrap, true);
      document.removeEventListener('keydown', escapeClose, true);
    }
  }
});

export {
  SimpleModal
};
